export const formatDate = (timestamp: number, config?: Intl.DateTimeFormatOptions) => {
  const defaultConfig: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }

  return new Intl.DateTimeFormat('en-US', config || defaultConfig).format(timestamp)
}
